import { Link } from "react-router-dom";
import { SectionLabel, Headline, Stamp } from "@/components/Doc";

const tenets = [
  ["We don't sell software.", "Nothing we install requires a login, a subscription, or a vendor. If a control needs a password to work, it isn't the control."],
  ["The controls are old on purpose.", "Two signatures, a call-back, a sealed envelope, a named deputy. These were standard practice in offices that ran without a network, and they still work because they don't depend on one."],
  ["Training that changes nothing is entertainment.", "Every module ends with a physical artifact and a written change with an owner and a date. We return in ninety days to see whether it held."],
  ["We stay in our lane.", "Longhand provides training and operating practice. We are not a cybersecurity firm, a law firm, or a compliance advisor, and we will tell you when you need one."],
];

export default function About() {
  return (
    <main className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28" data-testid="about-page">
      <SectionLabel right="Form LH-07">Doc. 07 — The Firm</SectionLabel>
      <div className="relative">
        <div className="absolute -top-2 right-0 hidden sm:block"><Stamp color="carbon" rotate={-7} size="md">For internal use</Stamp></div>
        <Headline as="h1" className="mt-10 text-4xl sm:text-5xl lg:text-6xl max-w-4xl">Operating practice from before the machine.</Headline>
      </div>
      <div className="grid lg:grid-cols-12 gap-12 mt-12">
        <div className="lg:col-span-7 t-body text-lg sm:text-xl leading-[1.65] flex flex-col gap-6">
          <p>Longhand is a small consulting firm. We install the operating practices that companies quietly deleted on their way to being digital: separation of duties, verified contact, written decisions, named deputies. We do it in a room, with your people, over two days, and we come back to check.</p>
          <p>The firm's premise is simple. The technology that lets one person do everything from one inbox also lets one impostor do everything from one inbox. The answer is not more technology. It is the restoration of a few procedures that never needed any.</p>
          <p>We don't publish client names, and we don't ask clients to publish ours. The work is confidential by default. If you want to know whether it has held somewhere like your company, ask us on the scoping call and we will tell you what we can.</p>
        </div>
        <div className="lg:col-span-4 lg:col-start-9 flex flex-col gap-8">
          {tenets.map(([h, t], i) => (
            <div key={h} className="border-t border-rule pt-4" data-testid={`tenet-${i + 1}`}>
              <span className="t-label text-rule">Tenet {String(i + 1).padStart(2, "0")}</span>
              <h3 className="t-head text-2xl mt-1">{h}</h3>
              <p className="t-body text-base mt-2 text-olive">{t}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-20 border-t border-carbon pt-12 flex flex-col sm:flex-row sm:items-center justify-between gap-6">
        <h2 className="t-head text-3xl sm:text-4xl">Start with the audit.</h2>
        <Link to="/audit" className="btn btn-stamp" data-testid="about-audit-btn">Take the Key Ring Audit</Link>
      </div>
    </main>
  );
}
